export const user = () => (
  <path
    d="M12 11a4 4 0 100-8 4 4 0 000 8zM4 18a3 3 0 013-3h10a3 3 0 110 6H7a3 3 0 01-3-3z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
